export default "__VITE_ASSET__Buem7kQ7__"